import React, { useState } from "react";
import { Question } from "../../question/Question.Model";
import { QuestionsAPI } from "../../question/QuestionsAPI";
import { AiConfigSelector, AiProvider } from "./AiConfig.Selector";

export function AdminQuestionAIPage() {
  const [rawQuestionContent, setRawQuestionContent] = useState("");
  const [aiProvider, setAiProvider] = useState<AiProvider>("GEMINI_VIA_REST");
  const [modelName, setModelName] = useState("gemini-1.5-flash");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<Question[] | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setResult(null);

    QuestionsAPI.addQuestionsWithAi(aiProvider, modelName)
      .executeV2({ rawContent: rawQuestionContent })
      .then((response) => {
        setResult(response);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="main-container">
      <h1>Create Questions using AI</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="rawContent">Raw Question Content</label>
          <textarea
            id="rawContent"
            className="form-control"
            rows={15}
            value={rawQuestionContent}
            onChange={(e) => setRawQuestionContent(e.target.value)}
            required
          />
        </div>
        <AiConfigSelector
          aiProvider={aiProvider}
          setAiProvider={setAiProvider}
          modelName={modelName}
          setModelName={setModelName}
        />
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Creating..." : "Create"}
        </button>
      </form>
      {error && <div className="alert alert-danger mt-3">{error}</div>}
      {result && (
        <div className="alert alert-success mt-3">
          <p>Successfully created {result.length} questions!</p>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}
